export default "__VITE_ASSET__35693e48__"